// src/utils/excelExport.js
import * as XLSX from 'xlsx';

export function importExcel(file) {
  return new Promise((resolve, reject) => {
    if (!file) {
      resolve([]);
      return;
    }

    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    
    reader.onload = (e) => {
      try {
        const binarystr = new Uint8Array(e.target.result);
        const wb = XLSX.read(binarystr, { type: 'array', raw: true, cellFormula: false });
        const wsname = wb.SheetNames[0];
        
        const productosItem = XLSX.utils.sheet_to_json(wb.Sheets[wsname]).map((value) => ({
          codigo: value['codigo'],
          nombre: value['nombre'],
          preciocompra: value['preciocompra'] || 1,
          preciosugerido: value['preciosugerido'] || 1,
          preciominimo: value['preciominimo'] || 1,
          descripcion: value['descripcion'] || 'N/A',
          tipo: value['tipo'] || "B",
          controlstock: value['controlstock'] || 1,
          estado: value['estado'] || 1,
          idcategoria: value['idcategoria'] || 1
        }));
        
        resolve(productosItem);
      } catch (error) {
        reject(error);
      }
    };
    
    reader.onerror = (error) => reject(error);
  });
}

